import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {Button, Checkbox, Col, Form, Icon, Input, message, Row, Select} from "antd";
import {Fade} from "react-reveal";
import GenericCropImage from "../../../Generic/GenericCropImage";
import GenericInput from "../../../Generic/GenericInput";
import NumberFormat from "react-number-format";
import {useValidationShorts} from "../../../../Hooks/Helpers";
import * as moment from "moment";
import useApi from "../../../../Hooks/Api";
import useAuth from "../../../../Hooks/Auth";
import {Env} from "../../../../Helpers/Env";
import {Images} from "../../../../Helpers/Images";
import useLocalStorage from "../../../../Hooks/Storage";
import {StorageVariables} from "../../../../Helpers/StoragesVariables";

moment.locale('pt-br');
const RegisterFinalForm = props => {

    const [loading,setLoading] = useState();
    const [imageVisible, setImageVisible] = useState(false);
    const {getFieldError, getFieldsValue, setFieldsValue, getFieldDecorator, validateFields} = props.form;
    const {numMinWithMask, isEmail, required, passwordStrength, isValidDate} = useValidationShorts();
    const api = useApi();
    const imageApi = useApi();
    let md5 = require('md5');
    const [googleFace, setGoogleFace] = useState(true);
    const googleToken = useRef(null);
    const facebookToken = useRef(null);
    const image = useRef(null);
    const {login} = useAuth();
    const hasProfileStorage = useLocalStorage(StorageVariables.hasSineProfile);
    const [allow, setAllow] = useState(false);
    let messaging = window.firebase?.messaging?.isSupported()? window.firebase.messaging() : null;
    const token = useRef(undefined);

    const doAfterRegister = async (res) => {
        message.success({
            icon: <> </>,
            content: <div style={{display: 'flex', fontWeight: 'bold', flexFlow: 'column'}}>
                <img style={{height: 45, marginBottom: 10}} src={Images.logo}/> <span> Seja bem-vindo(a). </span>
            </div>
        });

        login({
            token: res.api_key,
            user_id: res.user_id,
            email: res.profile.email,
            nickname: res.profile.nickname,
            avatar: res.profile.profile_picture?.thumbnail,
            addresses: res.addresses,
            name: (res.profile.first_name + ' ' + res.profile.last_name),
            last_profile: props.profile,
            gender: res.profile.gender,
            cpf: res.profile.cpf,
            phone: res.profile.cellphone_number,
            birthday: res.profile.birthday,
        });
       /* if (!res.crafty_club) {
            const res = await api.post(`crafty-club/register`, {});
        }*/
        hasProfileStorage.setPrimitive(false); // TODO retirar depois do bessa arrumar
        props.setStep();
    }


    const handleSubmit = () => {
        setLoading(true);
        validateFields(async (error, values) => {
            if (error) {
                setLoading(false);
                message.warning('Preencha os campos corretamente');
            } else {
                if(props.mobileVerified) {
                    values.mobile_verified = props.mobileVerified;
                    values.mobile_token = props.mobileToken;
                }
                if (image.current) {
                    values.profile_picture = image.current
                }
                if (googleToken.current) {
                    values.google_id = googleToken.current.google_id;
                    values.google_token = googleToken.current.google_token;
                }
                if (facebookToken.current) {
                    values.facebook_id = facebookToken.current.facebook_id;
                    values.facebook_token = facebookToken.current.facebook_token;
                }
                if (googleFace) {
                    values.password = md5(values.password);
                    values.confirm_password = md5(values.confirm_password);
                }
                values.cellphone_number = '+55' + props.userCell.replace(/\D/ig, '');
                values.birthday = moment(values.birthday,'DD/MM/YYYY').format('YYYY-MM-DD');
                values.cpf = values.cpf.replace(/\D/ig, '');
                values.application_name = Env.application_name;
                values.fcm_token = token.current || 'undefinedToken';

                let urlAux = '';
                urlAux = props.profile === 'worker'? 'register/worker' : 'register/customer';

                api.post(urlAux, values, (res) => {
                    setLoading(false);
                    window.gtag&& window.gtag('event', 'registerSuccess');
                    doAfterRegister(res);
                }, (e) => {
                    setLoading(false);
                    window.gtag&& window.gtag('event', 'registerFailure');
                    message.error(e.message || 'Não foi possivel registar, tente novamente mais tarde');
                });
            }
        })
    }

    const sendImage = async (item) => {
        setImageVisible(item);
        let auxFile = item.slice(23);
        imageApi.post('register/upload/profile-picture', {profile_picture: auxFile, filename: 'avatar.jpeg'}, (res) => {
            image.current = res.profile_picture;
        }, (e) => {
            message.error(e.message || 'Nao foi possivel trocar sua imagem, tente novamente');
        });
    };

    const passwordMatch = () => {
        return   {
            validator: (rule, value) => getFieldsValue().password === getFieldsValue().confirm_password,
            message: ' As senhas devem ser Iguais'
        }
    }

    const getToken = () => {
        messaging?.getToken().then(async (currentToken) => {
            token.current = currentToken;
        })
    }

    useEffect(() => {
        getToken()
    },[])

    return (
        <div>
            <Fade mountOnEnter>
                <div className='loginFormMobile' style={{width: '100%', margin: "auto", padding: '15px', borderRadius: '10px'}}>
                    <Row gutter={16} style={{marginBottom: 10, display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
                        <Col xs={24} md={24}>
                            <Row>
                                <Col span={24}>
                                    <GenericInput suffix={<Icon type="user" className={'primary-sub-color'} style={{fontSize: '17px'}}/>} required={true} form={props.form} error={getFieldError('first_name')} name='first_name' label='Nome' placeholder='Digite seu Nome' valueForMemo={getFieldsValue().first_name} />
                                </Col>
                                <Col span={24}>
                                    <GenericInput suffix={<Icon type="team" className={'primary-sub-color'} style={{fontSize: '17px'}}/>} required={true} form={props.form} error={getFieldError('last_name')} name='last_name' label='Sobrenome' placeholder='Digite seu Sobrenome' valueForMemo={getFieldsValue().last_name} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className={'genericInput'}>
                        <Form.Item
                            className={'hideDots'}
                            label={<span style={{ color: 'rgba(0, 0, 0, 0.65)', fontSize: '16px'}}><strong > Telefone </strong> </span>}>
                            <Input suffix={<Icon type="phone" className={'primary-sub-color'} style={{fontSize: '24px'}}/>} disabled={true} value={props.userCell} size={"large"} />
                        </Form.Item>
                    </Row>
                    <Row gutter={16}>
                        <Col xs={24} sm={24} className={'genericInput'}>
                            <Form.Item className='hideDots'required={true} validateStatus={getFieldError('cpf')&& 'error'} help={getFieldError('cpf')} label={<span style={{fontSize: '16px', color: 'rgba(0, 0, 0, 0.65)', fontWeight: 'bold'}}> Seu CPF </span>}>
                                {getFieldDecorator('cpf', {
                                    rules: [
                                        numMinWithMask(11),
                                        {
                                            required: true,
                                            message: 'Campo Obrigatório',
                                        },
                                    ],
                                })(
                                    <NumberFormat suffix={<Icon type="number" className={'primary-sub-color'} style={{fontSize: '16px'}}/>} style={{width: '100%'}} placeholder={'Seu CPF'} className='ant-input ant-input-lg' format={'###.###.###-##'} mask="_"/>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col xs={24} lg={24}>
                            <GenericInput rules={[isEmail(), required()]} suffix={<Icon type="mail" className={'primary-sub-color'} style={{fontSize: '17px'}}/>} required={true} form={props.form} error={getFieldError('email')} name='email' label='Email' placeholder='Digite seu email' valueForMemo={getFieldsValue().email} />
                        </Col>
                    </Row>
                    <Row gutter={16}>

                        <Col xs={24} sm={12} className={'genericInput'}>
                            <Form.Item required={true} className={'datePickerWidth hideDots'} validateStatus={getFieldError('birthday')&& 'error'} help={getFieldError('birthday')} label={<span style={{fontSize: '16px', color: 'rgba(0, 0, 0, 0.65)', fontWeight: 'bold'}}> Data de Nascimento </span>}>
                                {getFieldDecorator('birthday', {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Campo Obrigatório',
                                        },
                                        isValidDate()
                                    ],
                                })(
                                    <NumberFormat className={'ant-input ant-input-lg'} style={{marginTop: 5}} format="##/##/####" placeholder="DD/MM/YYYY"/>
                                )}
                            </Form.Item>
                        </Col>

                        <Col xs={24} lg={12} className={'genericInput'}>
                            <Form.Item required={true} className='hideDots' validateStatus={getFieldError('gender')&& 'error'} help={getFieldError('gender')} label={<span style={{fontSize: '16px', color: 'rgba(0, 0, 0, 0.65)', fontWeight: 'bold'}}> Seu Gênero</span>}>
                                {getFieldDecorator('gender', {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Campo Obrigatório',
                                        },
                                    ],
                                })(<Select
                                    mode="default"
                                    style={{ width: '100%',marginTop: 5 }}
                                    placeholder={"Escolha um Gênero"}
                                    allowClear={false}
                                    size={'large'}
                                    suffixIcon={<Icon type="down" className={'primary-sub-color'} style={{fontSize: '17px'}}/>}
                                >

                                    <Select.Option value={'male'}> Masculino </Select.Option>
                                    <Select.Option value={'female'}> Feminino </Select.Option>
                                    <Select.Option value={'transgender_male'}> Homem transgênero </Select.Option>
                                    <Select.Option value={'transgender_female'}> Mulher transgênero </Select.Option>
                                    <Select.Option value={'transsex_male'}> Homem Transexual </Select.Option>
                                    <Select.Option value={'transsex_female'}> Mulher Transexual </Select.Option>
                                    <Select.Option value={'unknown'}> Não sei responder </Select.Option>
                                    <Select.Option value={'not_anwswered'}> Prefiro não responder </Select.Option>
                                    <Select.Option value={'other'}> Outros </Select.Option>
                                </Select>)}
                            </Form.Item>
                        </Col>
                    </Row>
                    {googleFace && <Row gutter={16}>
                        <Col xs={24} sm={12}>
                            <GenericInput type='password' rules={[passwordStrength()]} suffix={<Icon type="lock" className={'primary-sub-color'} style={{fontSize: '16px'}}/>} required={true} form={props.form} error={getFieldError('password')} name='password' label='Senha' placeholder='Digite sua Senha' valueForMemo={getFieldsValue().password} />
                        </Col>
                        <Col xs={24} sm={12}>
                            <GenericInput type='password' rules={[passwordMatch(), required()]} suffix={<Icon type="lock" className={'primary-sub-color'} style={{fontSize: '16px'}}/>} required={true} form={props.form} error={getFieldError('confirm_password')} name='confirm_password' label='Confirme sua Senha' placeholder='Confirme sua Senha' valueForMemo={getFieldsValue().confirm_password} />
                        </Col>
                    </Row>}

                    {/*<div>
                        <GenericInput suffix={<Icon type="font-colors" className={'primary-sub-color'} style={{fontSize: '16px'}}/>} required={false} form={props.form} error={getFieldError('nickname')} name='nickname' label='Apelido' placeholder='Digite seu Apelido' valueForMemo={getFieldsValue().nickname} />
                    </div>*/}

                    {/*   <div>
                        <GenericInput suffix={<Icon type="info" className={'primary-sub-color'} style={{fontSize: '16px'}}/>} form={props.form} error={getFieldError('bio')} name='bio' label='Sobre Mim' placeholder='Digite um pouco sobre você' valueForMemo={getFieldsValue().bio} />
                    </div>*/}
                    <Row style={{display: 'flex', flexFlow: 'row', marginTop: 10}}>
                        <div>
                            <Checkbox defaultChecked={false} onChange={() => setAllow(!allow)}/>
                        </div>
                        <div >
                            <span style={{marginLeft: 5, fontSize: 12}}>
                            Ao clicar em Registrar você concorda com nossos
                            <a target={'_blank'} href={window.location.origin + '/termos'}> termos </a> e
                            <a target={'_blank'} href={window.location.origin + '/termos'}> políticas de privacidade </a>
                            </span>
                        </div>
                    </Row>
                    <Button className={'ant-btn-sub-primary'} loading={loading || imageApi.loading} disabled={loading || imageApi.loading || !allow} onClick={() => handleSubmit()} style={{width: '100%', marginTop: 20}} size={'large'}> Inscrever-se </Button>
                </div>
            </Fade>
        </div>
    );
};

RegisterFinalForm.propTypes = {
    mobileVerified: PropTypes.any,
    mobileToken: PropTypes.any
};

export default Form.create({name: 'RegisterForm'})(RegisterFinalForm);
